import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { TEAM_OVERVIEW_WIDGETS } from "#app/widgets/dashboards/team-overview-widgets";

/**
 * `/team/$teamId/overview` — the managed widget board (Workload, Unassigned,
 * Follow ups, Recent activity) on its own persisted `-overview` variant.
 */
function TeamOverviewRoute() {
  const { teamId } = Route.useParams();
  const scope = useMemo(
    () => ({ kind: "team" as const, teamId }),
    [teamId],
  );
  if (!teamId) return null;
  return (
    <Dashboard
      scope={scope}
      title="Overview"
      managedCatalog={TEAM_OVERVIEW_WIDGETS}
      surfaceVariant="overview"
      tabLinkedChrome
      personalOnly
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/overview")({
  component: TeamOverviewRoute,
});
